import React, { Component } from "react";
import { CanvasJSChart } from "canvasjs-react-charts";
import { withReportsList } from "../../shared/containers/containerReportsList";
import { withTimerangeIntelligence } from "../../shared/containers/containerTimerangeIntelligence";
import { withChartSensors } from "../../shared/containers/containerChartSensors";
import { withMapPositions } from "../../shared/containers/containerMapPositions";
import { states } from "../../reducers/queriesStates";
import Preloader from "../../shared/items/static/preloader";
import { getChartOptions } from "./chartDataService";
import "./chart.css";
import { withCurrentDevices } from "../../shared/containers/containerCurrentDevice";
import { withIntelligenceTimeRangePlayer } from "../../shared/containers/containerIntelligenceTimeRangePlayer";
import { withMapControl } from "../../shared/containers/containerMapControl";
import CookieService from "../../shared/services/cookiesService";
import configuration from "./../../config.json";

class Chart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: props.data !== undefined,
      dataValues: props.data === undefined ? null : props.data,
      carId: props.carId,
      getChart: false,
    };
  }

  componentDidMount() {
    const { onGetReportsList, chartSensorsDataState, chartSensorsData } = this.props;

    const { dataValues, carId } = this.state;

    if (dataValues !== null) {
      if (chartSensorsDataState === states.READY) {
        this.setState({ dataValues: chartSensorsData, isLoaded: true });
      } else {
        onGetReportsList();
      }
    } else {
      if (chartSensorsData !== null) {
        this.setState({ dataValues: chartSensorsData, isLoaded: true });
      } else if (carId !== null) {
        this.getChartData();
      }
    }
  }

  getChartData = () => {
    const { onGetChartSensors, reportsListData, startDate, endDate } = this.props;
    const { carId } = this.state;

    const authData = JSON.parse(CookieService.getCookie(configuration.cookieName));
    const email = authData.email;

    const charReports = !!localStorage.getItem(configuration.charReports)
      ? JSON.parse(localStorage.getItem(configuration.charReports))
      : [];

    let storageCharReport = charReports.filter((x) => {
      return x.email === email;
    })[0];

    const customChartId = storageCharReport !== undefined ? storageCharReport.id : null;

    const chartReport = reportsListData.filter((item) => {
      return (customChartId === null && item.buildType === 2 && item.patternReport !== null) || item.id === customChartId;
    })[0];

    if (chartReport) {
      onGetChartSensors(
        {
          carId,
          startDate,
          endDate,
        },
        chartReport
      );

      this.setState({ getChart: false });
    }
  };

  componentDidUpdate(prevProps) {
    const { reportsListDataState, chartSensorsDataState, mapPositionsDataState, chartSensorsData } = this.props;
    const { isLoaded, getChart } = this.state;

    if (getChart) {
      this.getChartData();
    }

    if (prevProps.reportsListDataState === states.REQUEST && reportsListDataState === states.READY) {
      this.getChartData();
    }

    if (mapPositionsDataState === states.REQUEST && isLoaded) {
      this.setState({ isLoaded: false });
    }

    if (mapPositionsDataState === states.READY && prevProps.mapPositionsDataState === states.REQUEST) {
      this.getChartData();
    }

    if (prevProps.chartSensorsDataState === states.REQUEST && chartSensorsDataState === states.READY) {
      this.setState({ dataValues: chartSensorsData, isLoaded: true });
    }
  }

  handleClick(date) {
    const { onSetCurrentPoint, mapPoints, onSetMapCenter } = this.props;

    const index = mapPoints.findLastIndex((point) => {
      return new Date(point.date) <= new Date(date);
    });

    onSetMapCenter({ lat: mapPoints[index].location[0], lng: mapPoints[index].location[1] });
    onSetCurrentPoint(mapPoints[index].index, date);
  }

  render() {
    const { dataValues, isLoaded } = this.state;

    if (!isLoaded) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    const { height = 300 } = this.props;

    const options = getChartOptions(dataValues, height, this.handleClick.bind(this));

    return (
      <div className="chartContainer">
        <CanvasJSChart options={options} />
      </div>
    );
  }
}

export default withMapControl(
  withIntelligenceTimeRangePlayer(withCurrentDevices(withMapPositions(withTimerangeIntelligence(withChartSensors(withReportsList(Chart))))))
);
